/** Identifies reserved type-ahead sections whose item is rendered as the persistent menu footer. */
export const MENU_FOOTER_SECTION_KEY_SUFFIX = '--system-menu-footer';
